 
import { Grid, Typography } from '@mui/material';
import React from 'react';

export default function PackageDetailsOverviewItem({ title, value }) {
  return (
    <Grid item xs={12} sm={6}>
      <Typography variant="body1">
        <strong>{title}:</strong> {value || 'N/A'}
      </Typography>
    </Grid>
  );
}
